// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1apH4","messages":"Chat_messages__imDiZ","dateDivider":"Chat_dateDivider__1qqAw"};